import React, { useEffect, useState } from 'react';
import './App.css';
import Landingpage from './Landingpage';
import PageNotFound from './PageNotFound';

import Main from './components/mainpage/Main';
import RequestSelection from './components/requestselection/RequestSelection';
import NonPoItems from './components/nonpoitems/NonPoItems';
import PoItems from './components/poitems/PoItems';
import CashAdvance from './components/cashadvance/CashAdvance';

import MyDashboard from './components/mydashboard/MyDashboard';
import Comptroller from './components/comptroller/Comptroller';
import MyDepartments from './components/mydepartments/MyDepartments';

import MyRequest from './components/myrequest/MyRequest';
import ToApprove from './components/toapprove/ToApprove';
import Approved from './components/approved/Approved';
import ForTransmittal from './components/fortransmittal/ForTransmittal';
import ForReview from './components/forreview/ForReview';
import Reviewed from './components/reviewed/Reviewed';
import AllRequests from './components/allrequests/AllRequests';
import OnHold from './components/onhold/OnHold';
import ForEndorsement from './components/forendorsement/ForEndorsement';

import InProcess from './components/inprocess/InProcess';
import CheckPreparation from './components/checkpreparation/CheckPreparation';
import CheckPrepared from './components/checkprepared/CheckPrepared';
import CheckAvailable from './components/checkavailable/CheckAvailable';
import Released from './components/released/Released';

import Returned from './components/returned/Returned';
import Rejected from './components/rejected/Rejected';
import Drafts from './components/drafts/Drafts';
import Draft from './components/draft/Draft';
import Backdrop from './components/backdrop/backdrop';
import ApproveDepartment from './components/approvedepartment/ApproveDepartment';
import SystemUsers from './components/systemusers/SystemUsers';
import PdfViewer from './components/pdfViewer/pdfViewer';

import CheckRequest from './components/checkrequest/CheckRequest';
import { Admin } from './components/admin';
// import 'materialize-css/dist/css/materialize.min.css';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { ProtectedRoute } from './protected.routes';

import CrfProvider, { CrfContext } from './CrfContext';
import axios from 'axios';
import AzureCloudRibbon from './AzureCloudRibbon';

function App() {
  // const [userInfo, setUserInfo] = useState('')
  // useEffect(() => {
  //   if (localStorage.token) {
  //     axios({
  //       method: 'GET',
  //       url: `${process.env.REACT_APP_API_KEY}/api/userInfo`,
  //       headers: {
  //         'Api-Key':
  //           '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
  //         Authorization: `Bearer ${localStorage.token}`
  //       }
  //     })
  //       .then(response => {
  //         const { data } = response.data
  //         setUserInfo(data.roles[0])
  //       })
  //       .catch(error => {
  //         console.log(error)
  //         localStorage.removeItem('token')
  //         window.location.reload()
  //       })
  //   }
  // }, [])
  return (
    <>
      <CrfProvider>
        <Router>
          <CrfContext.Consumer>
            {(context) => {
              const userInfo = context.state.userRole;
              return (
                <>
                  <AzureCloudRibbon />
                  <Switch>
                    <Route exact path="/Login" component={Landingpage} />
                    <ProtectedRoute exact path="/" component={userInfo === '' ? Backdrop : userInfo === 'System Admin' ? Admin : Main} />
                    <ProtectedRoute
                      path="/RequestSelection"
                      component={userInfo === '' ? Backdrop : userInfo === 'Requestor' ? RequestSelection : PageNotFound}
                    />
                    <ProtectedRoute
                      path="/NonPoItems"
                      component={userInfo === '' ? Backdrop : userInfo === 'Requestor' ? NonPoItems : PageNotFound}
                    />
                    <ProtectedRoute
                      path="/PoItems"
                      component={userInfo === '' ? Backdrop : userInfo === 'Requestor' && !context.state.isProject ? PoItems : PageNotFound}
                    />
                    <ProtectedRoute
                      path="/CashAdvance"
                      component={userInfo === '' ? Backdrop : userInfo === 'Requestor' ? CashAdvance : PageNotFound}
                    />
                    <ProtectedRoute
                      path="/CheckRequest/:id"
                      component={
                        userInfo === ''
                          ? Backdrop
                          : userInfo === 'Requestor' ||
                            userInfo === 'Accounting Staff' ||
                            userInfo === 'Accounting Manager' ||
                            userInfo === 'Department Head' ||
                            userInfo === 'Comptroller' ||
                            userInfo === 'COO'
                          ? CheckRequest
                          : PageNotFound
                      }
                    />

                    <ProtectedRoute path="/MyRequest" component={userInfo === '' ? Backdrop : userInfo === 'Requestor' ? MyRequest : PageNotFound} />
                    {/* <ProtectedRoute
              path='/MyDepartments'
              component={
                userInfo === ''
                  ? Backdrop
                  : userInfo === 'Requestor'
                  ? MyDepartments
                  : PageNotFound
              }
            /> */}

                    <ProtectedRoute
                      path="/MyDashboard"
                      component={userInfo === '' ? Backdrop : userInfo === 'Accounting Staff' ? MyDashboard : PageNotFound}
                    />

                    <ProtectedRoute
                      path="/Comptroller"
                      component={userInfo === '' ? Backdrop : userInfo === 'Comptroller' ? MyDashboard : PageNotFound}
                    />

                    <ProtectedRoute path="/COO" component={userInfo === '' ? Backdrop : userInfo === 'COO' ? MyDashboard : PageNotFound} />

                    <ProtectedRoute
                      path="/ToApprove"
                      component={userInfo === '' ? Backdrop : userInfo === 'Department Head' ? ToApprove : PageNotFound}
                    />
                    <ProtectedRoute
                      path="/Approved"
                      component={userInfo === '' ? Backdrop : userInfo === 'Department Head' ? Approved : PageNotFound}
                    />
                    <ProtectedRoute
                      path="/ForTransmittal"
                      component={userInfo === '' ? Backdrop : userInfo === 'Accounting Manager' ? ForTransmittal : PageNotFound}
                    />
                    <ProtectedRoute
                      path="/ForReview"
                      component={userInfo === '' ? Backdrop : userInfo === 'Accounting Manager' ? ForReview : PageNotFound}
                    />
                    <ProtectedRoute
                      path="/Reviewed"
                      component={userInfo === '' ? Backdrop : userInfo === 'Accounting Manager' ? Reviewed : PageNotFound}
                    />
                    <ProtectedRoute
                      path="/AllRequests"
                      component={userInfo === '' ? Backdrop : userInfo === 'Accounting Manager' ? AllRequests : PageNotFound}
                    />
                    <ProtectedRoute
                      path="/OnHold"
                      component={userInfo === '' ? Backdrop : userInfo === 'Accounting Manager' ? OnHold : PageNotFound}
                    />
                    <ProtectedRoute
                      path="/ForEndorsement"
                      component={userInfo === '' ? Backdrop : userInfo === 'Accounting Manager' ? ForEndorsement : PageNotFound}
                    />

                    <ProtectedRoute
                      path="/Returned"
                      component={userInfo === '' ? Backdrop : userInfo === 'Department Head' ? Returned : PageNotFound}
                    />
                    <ProtectedRoute
                      path="/Rejected"
                      component={userInfo === '' ? Backdrop : userInfo === 'Department Head' ? Rejected : PageNotFound}
                    />

                    {/* <ProtectedRoute
              path='/ApproveDepartment'
              component={
                userInfo === ''
                  ? Backdrop
                  : userInfo === 'Department Head'
                  ? ApproveDepartment
                  : PageNotFound
              }
            /> */}
                    {/* <ProtectedRoute
              path='/SystemUsers'
              component={
                userInfo === ''
                  ? Backdrop
                  : userInfo === 'Accounting Manager'
                  ? SystemUsers
                  : PageNotFound
              }
            /> */}

                    <ProtectedRoute
                      path="/InProcess"
                      component={userInfo === '' ? Backdrop : userInfo === 'Accounting Manager' ? InProcess : PageNotFound}
                    />
                    <ProtectedRoute
                      path="/CheckPreparation"
                      component={userInfo === '' ? Backdrop : userInfo === 'Accounting Manager' ? CheckPreparation : PageNotFound}
                    />
                    <ProtectedRoute
                      path="/CheckPrepared"
                      component={userInfo === '' ? Backdrop : userInfo === 'Accounting Manager' ? CheckPrepared : PageNotFound}
                    />
                    <ProtectedRoute
                      path="/CheckAvailable"
                      component={userInfo === '' ? Backdrop : userInfo === 'Accounting Manager' ? CheckAvailable : PageNotFound}
                    />
                    <ProtectedRoute
                      path="/Released"
                      component={userInfo === '' ? Backdrop : userInfo === 'Accounting Manager' ? Released : PageNotFound}
                    />

                    <ProtectedRoute path="/Drafts" component={userInfo === '' ? Backdrop : userInfo === 'Requestor' ? Drafts : PageNotFound} />
                    <ProtectedRoute path="/Draft/:id" component={userInfo === '' ? Backdrop : userInfo === 'Requestor' ? Draft : PageNotFound} />

                    <Route path="*" exact component={PageNotFound} />
                  </Switch>
                </>
              );
            }}
          </CrfContext.Consumer>
        </Router>
      </CrfProvider>
    </>
  );
}

export default App;
